import styled from 'styled-components';

export const StyledLogo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  img {
    width: 4rem;
  }
  h1 {
    color: #eee;
  }
`;
